import React, { useEffect, useState, useRef, use } from "react";
import { EditorState, ContentState, Modifier } from "draft-js";
import "draft-js/dist/Draft.css";
import { IconButton, Tooltip } from "@material-ui/core";
import {
  Button,
  Box,
  Chip,
  Typography,
  Paper,
  Divider,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import UploadIcon from "@mui/icons-material/Upload";
import MicIcon from "@mui/icons-material/Mic";
import { Menu, MenuItem } from "@material-ui/core";
import { Delete } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  checkGrammar,
  checkGrammarFluency,
  checkOCR,
} from "../../services/englishCheckers";
import Loader from "../../utils/loader";
import EditIcon from "@mui/icons-material/Edit";
import { toast, ToastContainer } from "react-toastify";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import CheckIcon from "@mui/icons-material/Check";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CoAutherTopMenubar from "../pages/CoAutherTopMenubar";
import CoauthorModal from "./FormComponents/CoAuthor_Model";
import { ListItemText } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";
import SelectDropdownMui from "../ReusableComponents/SelectDropdownMui";
import CoAuthorLowerModel from "./FormComponents/CoAuthorLowerModel";
import { strCount } from "../Editor/utilize";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import documentService from "../../services/document";
import { useDispatch, useSelector } from "react-redux";
import { resetTemplateName } from "../../redux/coauthor/coauthor.action";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import {
  closeLeftNavbar,
  closeLowerModalAndOpenLeftNavbar,
  openLeftNavbar,
  openLowerModalAndCloseLeftNavbar,
  closeLowerModal,
} from "../../redux/handleSideNavBarAndModel/handleStatus.action";
import { withStyles } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import htmlToDraft from "html-to-draftjs";
import swal from "sweetalert";
import { reviewDocument } from "../../services/teamCollbarationServices";
import blogService from "../../services/blogServices";
import { DownloadOptionModal } from "../MyDocumentsCardsModal";
import aireviewicon from "../../static/AI_Review_color.png";
import paraphrase_logo from "../../static/Paraphrase 1.png";
import paraphrase_White from "../../static/Paraphraser_White.png";
import paraphrase_Gray from "../../static/Paraphrase 2.png";
import HeadingB from "../Cards/HeadingB";
import JoditEditor from "jodit-react";
import JoditEditorComp from "../ReusableComponents/JoditEditorComp";
import SuggestionComp from "../ReusableComponents/SuggestionComp";
import TagButtonComp from "../ReusableComponents/TagButtonComp";
import CheckboxMui from "../ReusableComponents/CheckBoxMui";
import { FaBookOpen } from "react-icons/fa";
import { asBlob } from "html-docx-js-typescript";
import { saveAs } from "file-saver";
import { CoAuthor_Aireviewcomponent } from "./FormComponents/CoAuthor_Aireview";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import {
  closeRightModalAndOpenLeftNavbar,
  openRightModalAndCloseLeftNavbar,
  closeRightModal,
} from "../../redux/handleSideNavBarAndModel/handleStatus.action";
import "./CoAuthorNewProject.css";
import {
  fullSizeEditor,
  normalSizeEditor,
} from "../../redux/manageFullSizeEditor/fullSizeEditor.action";
import {
  selectCoauthorContent,
  clearCoauthorContent,
} from "../../redux/coauthorSelectedContent/coauthorSelectedContent.action";
import { addUserLogs } from "../../services/userLogServices";
import { useCheckFeatureAccess } from "../CheckFeature";
import { useCheckSubscriptionPlanAccess } from "../SubscriptionAccess";
import SubscriptionRequired from "../SubscriptionRequired";
import { checkAIRequestLimit } from "../aiRequestLimit";
import RichTextEditor from "../ReusableComponents/CustomEditor";
import mammoth from "mammoth";
import { Spellcheck } from "@mui/icons-material";
import CoAuthorTourBot from "../../bot/co_author_New_ProjectBot";
import { getBotAccess, BOT_TYPES } from "../settingsNew";

// ─── STYLE TOKENS ───────────────────────────────────────────────────────────
const COLORS = {
  bg: "#f0f2f8",
  surface: "#ffffff",
  surfaceAlt: "rgba(255,255,255,0.85)",
  border: "rgba(99,120,180,0.15)",
  borderHover: "rgba(99,120,180,0.35)",
  accent: "#4f6ef7",
  accentLight: "#eef1ff",
  accentDark: "#3a57d4",
  success: "#22c55e",
  successLight: "#f0fdf4",
  error: "#ef4444",
  errorLight: "#fef2f2",
  warning: "#f59e0b",
  textPrimary: "#1a1d2e",
  textSecondary: "#64748b",
  textMuted: "#94a3b8",
  sidebar: "#1a1d2e",
  sidebarText: "rgba(255,255,255,0.75)",
  sidebarActive: "rgba(79,110,247,0.18)",
};

const SHADOW = {
  sm: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
  md: "0 4px 16px rgba(79,110,247,0.08), 0 2px 6px rgba(0,0,0,0.06)",
  lg: "0 8px 32px rgba(79,110,247,0.12), 0 4px 12px rgba(0,0,0,0.08)",
  panel: "0 0 0 1px rgba(99,120,180,0.12), 0 8px 32px rgba(0,0,0,0.06)",
};

const RADIUS = { sm: "8px", md: "12px", lg: "16px", xl: "20px" };

// ─── MODERN TOOLBAR CHIP BUTTON ──────────────────────────────────────────────
const ToolbarChip = ({
  icon,
  label,
  onClick,
  disabled,
  color = "default",
  active = false,
}) => (
  <Chip
    icon={icon}
    label={label}
    onClick={onClick}
    disabled={disabled}
    size="small"
    sx={{
      height: 34,
      px: 0.5,
      fontWeight: 600,
      fontSize: "0.78rem",
      letterSpacing: "0.01em",
      cursor: disabled ? "not-allowed" : "pointer",
      border: "1.5px solid",
      borderColor: active
        ? COLORS.accent
        : color === "success"
          ? COLORS.success
          : color === "error"
            ? COLORS.error
            : COLORS.border,
      bgcolor: active
        ? COLORS.accentLight
        : color === "success"
          ? COLORS.successLight
          : color === "error"
            ? COLORS.errorLight
            : COLORS.surface,
      color: active
        ? COLORS.accent
        : color === "success"
          ? COLORS.success
          : color === "error"
            ? COLORS.error
            : COLORS.textPrimary,
      transition: "all 0.18s ease",
      "&:hover": {
        bgcolor: active ? COLORS.accentLight : COLORS.accentLight,
        borderColor: COLORS.accent,
        color: COLORS.accent,
        transform: "translateY(-1px)",
        boxShadow: SHADOW.sm,
      },
      "& .MuiChip-icon": { fontSize: "1rem" },
    }}
  />
);

// ─── ICON ACTION BUTTON ──────────────────────────────────────────────────────
const ActionIconBtn = ({
  title,
  onClick,
  disabled,
  color,
  children,
  size = 36,
}) => (
  <Tooltip title={title} arrow>
    <span>
      <IconButton
        onClick={onClick}
        disabled={disabled}
        disableTouchRipple
        size="small"
        style={{
          width: size,
          height: size,
          borderRadius: RADIUS.sm,
          border: `1.5px solid ${COLORS.border}`,
          backgroundColor: COLORS.surface,
          color: color || COLORS.textSecondary,
          transition: "all 0.18s ease",
          opacity: disabled ? 0.4 : 1,
        }}
        onMouseEnter={(e) => {
          if (!disabled) {
            e.currentTarget.style.backgroundColor = COLORS.accentLight;
            e.currentTarget.style.borderColor = COLORS.accent;
            e.currentTarget.style.color = COLORS.accent;
            e.currentTarget.style.transform = "translateY(-1px)";
          }
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = COLORS.surface;
          e.currentTarget.style.borderColor = COLORS.border;
          e.currentTarget.style.color = color || COLORS.textSecondary;
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        {children}
      </IconButton>
    </span>
  </Tooltip>
);

// ─── WORD COUNT BADGE ────────────────────────────────────────────────────────
const WordCountBadge = ({ count, max = 2500 }) => {
  const pct = Math.min((count / max) * 100, 100);
  const color =
    pct > 90 ? COLORS.error : pct > 70 ? COLORS.warning : COLORS.accent;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.5,
        py: 0.5,
        borderRadius: RADIUS.sm,
        bgcolor: COLORS.accentLight,
        border: `1.5px solid ${COLORS.border}`,
      }}
    >
      <FiberManualRecordIcon sx={{ fontSize: 10, color }} />
      <Typography
        variant="caption"
        sx={{ fontWeight: 700, color: COLORS.textPrimary, fontSize: "0.78rem" }}
      >
        {count}
        <Typography
          component="span"
          variant="caption"
          sx={{ color: COLORS.textMuted, fontWeight: 500 }}
        >
          {" "}
          / {max} words
        </Typography>
      </Typography>
    </Box>
  );
};

// ─── RIGHT PANEL HEADER ──────────────────────────────────────────────────────
const PanelHeader = ({ title, icon, onClose }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 2.5,
      py: 1.75,
      borderBottom: `1px solid ${COLORS.border}`,
      bgcolor: COLORS.surface,
      position: "sticky",
      top: 0,
      zIndex: 1,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
      {icon}
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "0.95rem",
          color: COLORS.textPrimary,
          letterSpacing: "-0.01em",
        }}
      >
        {title}
      </Typography>
    </Box>
    <IconButton
      size="small"
      onClick={onClose}
      sx={{
        width: 30,
        height: 30,
        borderRadius: RADIUS.sm,
        bgcolor: COLORS.errorLight,
        color: COLORS.error,
        "&:hover": { bgcolor: COLORS.error, color: "#fff" },
        transition: "all 0.18s",
      }}
    >
      <CloseIcon sx={{ fontSize: 16 }} />
    </IconButton>
  </Box>
);

// ─── BOTTOM TOOLBAR ──────────────────────────────────────────────────────────
const BottomToolbar = ({
  mobileView,
  totalWords,
  accessToParaphrase,
  accessToSummarize,
  accessToOCR,
  accessToDelete,
  accessToUpload,
  accessToTranslate,
  accessToEdit,
  isDarkMode,
  isRecording,
  trial,
  isGrammarCheck,
  docId,
  handleParaphraseClick,
  handleSummariserClick,
  ocrCheck,
  grammarCheckClick,
  handleDeleteFormain,
  handleFileChange,
  openDownloadModal,
  handleCopyFormain,
  handleTranslateClick,
  handleMicClick,
  paraphrase_logo,
  paraphrase_White,
  paraphrase_Gray,
  editorStyle,
}) => (
  <Paper
    elevation={0}
    sx={{
      ...editorStyle,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 1,
      px: 2,
      py: 1.25,
      borderRadius: `0 0 ${RADIUS.lg} ${RADIUS.lg}`,
      border: `1px solid ${COLORS.border}`,
      borderTop: `2px solid ${COLORS.border}`,
      bgcolor: COLORS.surface,
      boxShadow: SHADOW.sm,
      minHeight: 54,
    }}
  >
    {/* Left: Word count */}
    <WordCountBadge count={totalWords} />

    {/* Center: AI Feature buttons */}
    {!trial && !isGrammarCheck && (
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}
      >
        <ToolbarChip
          icon={
            <img
              src={
                !accessToParaphrase
                  ? paraphrase_Gray
                  : isDarkMode
                    ? paraphrase_White
                    : paraphrase_logo
              }
              alt=""
              style={{ width: 16 }}
            />
          }
          label="Paraphrase"
          onClick={handleParaphraseClick}
          disabled={!accessToParaphrase}
        />
        <ToolbarChip
          icon={<FaBookOpen style={{ fontSize: 14 }} />}
          label="Summarize"
          onClick={handleSummariserClick}
          disabled={!accessToSummarize}
        />
        <ToolbarChip
          icon={<span style={{ fontSize: 11, fontWeight: 800 }}>OCR</span>}
          label=""
          onClick={ocrCheck}
          disabled={!accessToOCR}
        />
        <ToolbarChip
          icon={<Spellcheck sx={{ fontSize: 16 }} />}
          label="Grammar Check"
          onClick={grammarCheckClick}
          color="success"
        />
      </Box>
    )}

    {/* Right: Action icons */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
      {mobileView && <WordCountBadge count={totalWords} />}

      <ActionIconBtn
        title="Delete"
        onClick={handleDeleteFormain}
        disabled={!accessToDelete}
        color={COLORS.error}
      >
        <Delete sx={{ fontSize: 18 }} />
      </ActionIconBtn>

      <ActionIconBtn
        title="Upload (.docx, .txt)"
        onClick={handleFileChange}
        disabled={!accessToUpload}
        color={COLORS.accent}
      >
        <UploadIcon sx={{ fontSize: 18 }} />
      </ActionIconBtn>

      {!trial && docId && (
        <ActionIconBtn
          title="Download"
          onClick={openDownloadModal}
          color={COLORS.success}
        >
          <DownloadIcon sx={{ fontSize: 18 }} />
        </ActionIconBtn>
      )}

      <ActionIconBtn
        title="Copy"
        onClick={handleCopyFormain}
        color={COLORS.accent}
      >
        <ContentCopyIcon sx={{ fontSize: 18 }} />
      </ActionIconBtn>

      {!trial && (
        <ActionIconBtn
          title="Translate"
          onClick={handleTranslateClick}
          disabled={!accessToTranslate}
          color="#8b5cf6"
        >
          <TranslateIcon sx={{ fontSize: 18 }} />
        </ActionIconBtn>
      )}

      <ActionIconBtn
        title={isRecording ? "Stop Recording" : "Mic"}
        onClick={handleMicClick}
        color={isRecording ? COLORS.error : COLORS.textSecondary}
      >
        <MicIcon
          sx={{
            fontSize: 18,
            animation: isRecording ? "pulse 1s infinite" : "none",
          }}
        />
      </ActionIconBtn>
    </Box>
  </Paper>
);

// ────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ────────────────────────────────────────────────────────────────────────────
const CoAuthorNewProject = ({
  docId = "",
  isCoAuthor = true,
  isGrammarCheck,
  trial = false,
  userId,
  hidecorrectnessbar,
}) => {
  const editorRef = useRef(null);
  const editor = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  // Speech recognition refs
  const recognitionRef = useRef(null);
  const [transcriptBuffer, setTranscriptBuffer] = useState("");

  // ---------- useStates ----------------
  const [loading, setLoading] = useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [secondaryeditorStateSummarizer, setSecondaryEditorStateSummarizer] =
    useState(EditorState.createEmpty());
  const [trackIsModelOpen, setTrackIsModalOpen] = useState(true);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [acceptAllClicked, setAcceptAllClicked] = useState(false);
  const [ignoreAllClicked, setIgnoreAllClicked] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [docApiCalled, setDocApiCalled] = useState(false);
  const [blogApiCalled, setBlogApiCalled] = useState(false);
  const [newDocId, setNewDocId] = useState("");
  const [circularLoader, setCircularLoader] = useState(false);
  const [viewOnlyAccess, setViewOnlyAccess] = useState(false);
  const [totalWords, setTotalWords] = useState(0);
  const [maxCountDisplayed, setMaxCountDisplayed] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [editDropdown, setEditDropdown] = useState(null);
  const [selectedEditOption, setSelectedEditOption] = useState(true);
  const [showTranslator1, setShowTranslator1] = useState(false);
  const [showSummariser1, setShowSummariser1] = useState(false);
  const [showParaphraser1, setShowParaphraser1] = useState(false);
  const [callGrammerCheck, setCallGrammerCheck] = useState(false);
  const [firstTime, setFirstTime] = useState(0);
  const [callSummarise, setCallSummarise] = useState(false);
  const [showTranslateModel, setShowTranslateModel] = useState(false);
  const [docName, setDocName] = useState("");
  const [updateDocName, setUpdateDocName] = useState(false);
  const [mountedFromUpload, setMountedFromUpload] = useState(false);
  const [sharedDocument, setSharedDocument] = useState(false);
  const [removeHighlight, setRemoveHighlight] = useState(false);
  const [clickSubmitForReview, setClickSubmitForReview] = useState(false);
  const [isModifiedDoc, setIsModifiedDoc] = useState(false);
  const [docInitialContent, setDocInitialContent] = useState("");
  const [docCurrentContent, setDocCurrentContent] = useState("");
  const [subReqOpen, setSubReqOpen] = useState(false);
  const [folderId, setFolderId] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const [editorValue, setEditorValue] = useState("");
  const [sentenceResult, setSentenceResult] = useState([]);
  const [isSuggestion, setIsSuggestion] = useState(false);
  const [isAIOpen, setIsAIOpen] = useState(false);
  const [formality, setFormality] = useState("");
  const [tone, setTone] = useState("");
  const [newSentences, setNewSentences] = useState([]);
  const [suggestionLoader, setSuggestionLoader] = useState(false);
  const [profession, setProfession] = useState("");
  const [tags, setTags] = useState([]);
  const [showAireviewContent, setshowAireviewContent] = useState(false);
  const [showGoals, setShowGoals] = useState(false);
  const [ignoredSuggestions, setIgnoredSuggestions] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [selectedContent, setSelectedContent] = useState(null);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isFeatureInside, setIsFeatureInside] = useState(false);

  // State for word limit warning dialog (NEW)
  const [wordLimitDialogOpen, setWordLimitDialogOpen] = useState(false);
  const [wordLimitExceeded, setWordLimitExceeded] = useState(false);
  // ---------- useStates End----------------

  //----------- UseSelectors ---------------------
  const { isFullSize } = useSelector((state) => state?.manageFullSizeEditor);
  const userDetails = useSelector((user) => user);
  const userID = userId ? userId : userDetails.user.currentUser._id;
  const currentNavItem = useSelector(
    (state) => state.manageCoauthorNavReducer.currentCoauthorNavItem,
  );
  const uploadDocumentValue = useSelector(
    (state) => state.templateName.uploadDocument,
  );
  const sharedFolderId = useSelector(
    (state) => state.templateName.shareFolderId,
  );
  const sharedDocumentValue = useSelector(
    (state) => state.templateName.sharedDocumentStatus,
  );
  const selectedTemplateName = useSelector(
    (state) => state.templateName.templateName,
  );
  const { rightModalOpen, leftNavbarOpen, lowerModelOpen } = useSelector(
    (state) => state.handleModelAndSideBavBar,
  );
  //----------- UseSelectors End-----------------

  //----------- FeatureAccess ---------------
  const accessToParaphrase = useCheckFeatureAccess(
    currentNavItem,
    "paraphrase",
  );
  const accessToSummarize = useCheckFeatureAccess(currentNavItem, "summarize");
  const accessToNewDoc = useCheckFeatureAccess(currentNavItem, "newDocument");
  const accessToWriteBlog = useCheckFeatureAccess(currentNavItem, "writeBlog");
  const accessToEdit = accessToNewDoc || accessToWriteBlog;
  const accessToOCR = useCheckFeatureAccess(currentNavItem, "ocr");
  const accessToDelete = useCheckFeatureAccess(currentNavItem, "delete");
  const accessToUpload = useCheckFeatureAccess(currentNavItem, "upload");
  const accessToTranslate = useCheckFeatureAccess(currentNavItem, "translate");
  const accessToMic = useCheckSubscriptionPlanAccess("mic");
  //----------- FeatureAccess End --------------

  //----------- Subscription access ------------
  const accessToDocumentScreen = useCheckSubscriptionPlanAccess("Document");
  const accessToGrammarCheckScreen =
    useCheckSubscriptionPlanAccess("Grammar Check");
  const accessToCoAuthorScreen = useCheckSubscriptionPlanAccess("CoAuthor");
  const accessToBlogScreen = useCheckSubscriptionPlanAccess("Blogs");
  const accessToTagsScreen = useCheckSubscriptionPlanAccess("Tags");
  const [isChevronOpen, setIsChevronOpen] = useState(false);
  const [showCoAuthorBot, setShowCoAuthorBot] = useState(false);

  var mobileView = windowWidth < 1330;
  const CHEVRON_WIDTH = 280;
  const RIGHT_CONTENT_PANEL_WIDTH = 468;
  const LOWER_MODEL_PANEL_WIDTH = 440;
  const REVIEW_PANEL_WIDTH = 380;
  const isCoAuthorContentPanelOpen =
    rightModalOpen && !isGrammarCheck && !showAireviewContent;

  const editorShiftStyle = {
    transition: "padding-right 0.3s ease",
    paddingRight: "0px",
  };
  //----------- Subscription access end-----------

  const professionList = [
    {
      name: "Content Writer",
      value: "Content Writer",
    },
    {
      name: "Copywriter",
      value: "Copywriter",
    },
    {
      name: "Technical writer",
      value: "Technical writer",
    },
    {
      name: "Research Analyst",
      value: "Research Analyst",
    },
  ];

  const templateData = [
    {
      name: "Cold-Email",
      data: `<div >

      <p><h3>Subject Line:</h3> Compelling Subject That Grabs Attention</p>

      <p><h3>Greeting:</h3> Hi [Recipient's Name],</p>

      <p><h3>Introduction:</h3> I hope this email finds you well. My name is [Your Name], and I am reaching out to you. [Briefly introduce yourself and mention a common interest or connection.]</p>

      <p><h3>Value Proposition:</h3> I want to share with you the exciting value [Your Product/Service/Proposition] brings. [Explain how it can benefit the recipient and address a pain point.]</p>

      <p><h3>Relevance:</h3> Considering [Recipient's Company/Needs/Challenges], I believe our [Product/Service/Proposition] is particularly relevant. [Customize and explain why it aligns with their specific situation.]</p>

      <p><h3>Call to Action:</h3> I would love to discuss this further with you. Could we schedule a brief call at your earliest convenience? [Provide options for scheduling or another clear CTA.]</p>

      <p><h3>Social Proof (Optional):</h3> We've had success working with companies like [Client Name] and achieved [mention any notable achievements]. [Optional: Include a brief testimonial or success story.]</p>

      <p><h3>Closing:</h3> Thank you for considering [Your Product/Service/Proposition]. I look forward to the possibility of working together.</p>

      <p><h3>Best regards:</h3> <br> [Your Full Name] <br> [Your Position] <br> [Your Company]</p>

      <p><h3>Contact Information:</h3> <br> [Your Email Address] <br> [Your Phone Number]</p>


      </div>
      `,
    },
    {
      name: "Resume",
      data: `  <div style={{margin:"10px"}}>
      <span><strong>Your Name :</strong> Lorem ipsum dolor sit amet, consectetuer adipiscing elit </span> <br />

    <span>  <strong>Address :</strong> 123 Your Street <br />
      Your City, ST 12345 <br />
      (123) 456-7890 <br />
      no_reply@example.com
    </span>

    <div class="section" style="margin-top: 20px">
      <h3>EXPERIENCE</h3>
      <p>
        <strong>Company, Location — Job Title</strong><br />
        MONTH 20XX - PRESENT<br />
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh.
      </p>

      <p>
        <strong>Company, Location — Job Title</strong><br />
        MONTH 20XX - MONTH 20XX<br />
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh.
      </p>

      <p>
        <strong>Company, Location — Job Title</strong><br />
        MONTH 20XX - MONTH 20XX<br />
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh.
      </p>
    </div>

    <div class="section" style="margin-top: 20px">
      <h3>EDUCATION</h3>
      <p>
        <strong>School Name, Location — Degree</strong><br />
        MONTH 20XX - MONTH 20XX<br />
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore.
      </p>

      <p>
        <strong>School Name, Location — Degree</strong><br />
        MONTH 20XX - MONTH 20XX<br />
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh.
      </p>
    </div>

    <div class="section" style="margin-top: 20px">
      <h3>PROJECTS</h3>
      <p>
        <strong>Project Name — Detail</strong><br />
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit.
      </p>
    </div>

    <div class="section" style="margin-top: 20px">
      <h3>SKILLS</h3>
      <ul>
        <li>Lorem ipsum dolor sit amet.</li>
        <li>Consectetuer adipiscing elit.</li>
        <li>Sed diam nonummy nibh euismod tincidunt.</li>
        <li>L​​​‌​aoreet dolore magna aliquam erat volutpat.</li>
      </ul>
    </div>

    <div class="section" style="margin-top: 20px">
      <h3>AWARDS</h3>
      <p>
        <span>Lorem ipsum dolor sit amet Consectetuer adipiscing elit, Sed diam nonummy Nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.</span>
      </p>

      <p>
        <span>Lorem ipsum dolor sit amet Consectetuer adipiscing elit, Sed diam nonummy Nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.</span>
      </p>
    </div>

    <div class="section" style="margin-top: 20px">
      <h3>LANGUAGES</h3>
      <p>Lorem ipsum, Dolor sit amet, Consectetuer</p>
    </div>  <div>`,
    },
    {
      name: "Essay",
      data: `<div >



      <h3>Introduction</h3>

      <p>
        Your essay begins with your introduction. It is important to capture your reader’s interest, so make sure you have an attention-grabbing hook. Your introduction is a paragraph that provides your reader with the relevant general background information on your topic. Using this context to ease your reader into the subject, you should then state your thesis statement. This is the main focus of your essay. A thesis statement is not a fact but something that can be discussed and analyzed. After stating your thesis, you should include an organizational statement. This functions as a roadmap that introduces the points you will make to support your thesis in the order in which they will appear in your body paragraphs.
      </p>

      <br />

      <h3>Body Paragraphs:</h3>

      <p>
        Body paragraphs are the bulk of your essay that provides substance to your argument with core analysis. These paragraphs are composed of points to support your thesis statement. It is helpful to separate your main claims into different paragraphs, making each claim a topic sentence. A topic sentence begins a body paragraph, introducing what your paragraph will be about. You must provide evidence (such as researched quotes or statistics) to back up and explore your topic sentence. You must provide the appropriate references for any evidence you cite. The evidence provided must be analyzed to explain how this idea proves or backs up your thesis. It is important that everything in your essay should be relevant to your thesis. This link is made at the end of the paragraph, tying back to the thesis statement and leading into the next point as a transition sentence. It is important to cite and use transition words in your essay to help create a smooth flow of your ideas. You may have as many body paragraphs as you’d like, but each body paragraph will follow the same format (beginning with a topic sentence, providing evidence and analysis to back up this claim, before linking your idea with your thesis statement).
      </p>

      <br />

      <h3>Conclusion</h3>

      <p>
        Your conclusion is the wrap-up of your essay. Here you must summarize the main points of your essay. You are to review your topic sentences and main argument, but you must not introduce any new ideas to your essay at this stage. Instead, re-emphasize your thesis statement and how your evidence and analysis support your points. In your concluding thoughts, you could appeal to the readers to see that you have come to a logical conclusion. You could also show why your argument matters, or simply end your essay with a memorable final statement.
      </p>

      <br />

      <h3>References:</h3>

      <p>
        If you have included evidence via in-text citations in your essay, you must cite it fully in a References section at the end of your essay. It is recommended to use either APA or MLA citations.
      </p>

      <br />
      <br />

      <h3>Structure:</h3>

      <p>An essay can be broken down into three main sections.</p>

      <br />

      <h3>Introduction</h3>

      <ul>
        <li>Background information</li>
        <li>Thesis statement</li>
        <li>Organizational statement/roadmap</li>
      </ul>

      <br />

      <h3>Body Paragraphs (repeat as many times as needed)</h3>

      <ul>
        <li>Topic Sentence</li>
        <li>Evidence</li>
        <li>Analysis</li>
        <li>Link to the thesis statement</li>
      </ul>

      <br />

      <h3>Conclusion</h3>

      <ul>
        <li>To sum up the main points,</li>
        <li>Then tie it back to the thesis statement.</li>
        <li>Final thoughts</li>
      </ul>

      <br />

      <p>
        If needed, include a references section at the end for any works cited.
      </p>



      </div>`,
    },
    {
      name: "Business Letter",
      data: `<div style={{margin:"10px"}}>

      <h3>Your Company's Letterhead</h3>
      <p>
        <span>If applicable, include your company's letterhead at the top of the letter, which typically features the company's logo, name, address, and contact information.</span>
      </p>

      <h3>Date</h3>
      <p>
        <span>Below the letterhead or your address, add the current date. Format it as Month Day, Year (e.g., August 15, 2023).</span>
      </p>

      <h3>Recipient's Address</h3>
      <p>
        <span>Leave a few lines and then include the recipient's name, title, company name, street address, city, and postal code.</span>
      </p>

      <h3>Salutation</h3>
      <p>
        <span>Start with a formal salutation, addressing the recipient with their appropriate title and last name (e.g., 'Dear Mr. Smith,').</span>
      </p>

      <h3>Body of the Letter</h3>
      <p>
        <span>In the body of the letter, maintain a professional and formal tone. Address the purpose of the letter, provide details, and communicate your message clearly.</span>
      </p>

      <h3>Closing</h3>
      <p>
        <span>Close the letter with a formal closing (e.g., 'Sincerely,' 'Yours faithfully,') followed by your full name and title.</span>
      </p>

      <h3>Signature (If Applicable)</h3>
      <p>
        <span>Leave space for your physical signature above your typed name. If the letter is being sent digitally, you can skip this step.</span>
      </p>

      <h3>Enclosures (If Applicable)</h3>
      <p>
        <span>If you're enclosing additional documents or materials, list them below your signature or closing.</span>
      </p>


      </div>
      `,
    },
    {
      name: "Meeting-Notes",
      data: `


      <div  >
      <!-- Meeting Details -->
<h3>Meeting Date:</h3>
<p>[Insert Meeting Date]</p>

<h3>Time:</h3>
<p>[Insert Meeting Time]</p>

<h3>Location:</h3>
<p>[Insert Meeting Location, if applicable]</p>

<!-- List of Attendees -->
<h3>List of Attendees:</h3>
<p>
  Attendant's name<br />
  Attendant's name<br />
  Attendant's name
</p>

<!-- Agenda -->
<h3>Agenda:</h3>
<p>
  <em>Topic 1:</em> [Insert Topic 1]<br />
  <em>Summary:</em> [Insert Summary]<br />
  <em>Discussion:</em> [Insert Discussion]<br />
  <em>Decisions:</em> [Insert Decisions]<br />

  <em>Topic 2:</em> [Insert Topic 2]<br />
  <em>Summary:</em> [Insert Summary]<br />
  <em>Discussion:</em> [Insert Discussion]<br />
  <em>Decisions:</em> [Insert Decisions]<br />

  <em>Topic 3:</em> [Insert Topic 3]<br />
  <em>Summary:</em> [Insert Summary]<br />
  <em>Discussion:</em> [Insert Discussion]<br />
  <em>Decisions:</em> [Insert Decisions]
</p>

<!-- Discussion and Decisions -->
<h3>Discussion and Decisions:</h3>
<p>
  Provide a summary of the discussions for each agenda item. Include key points, viewpoints, and decisions made.
</p>

<!-- Action Items -->
<h3>Action Items:</h3>
<p>
  - [Action Item 1: Description, Assigned to, Due Date]<br />
  - [Action Item 2: Description, Assigned to, Due Date]<br />
  - [Action Item 3: Description, Assigned to, Due Date]
</p>

<!-- Next Steps -->
<h3>Next Steps:</h3>
<p>
  Outline the next steps to be taken after the meeting, including tasks, responsibilities, and timelines.
</p>

<!-- Open Issues -->
<h3>Open Issues:</h3>
<p>
  Note any issues or topics that require further discussion or resolution. Specify who will address these issues and when.
</p>

<!-- Additional Notes -->
<h3>Additional Notes:</h3>
<p>
  Include any additional notes, comments, or observations relevant to the meeting.
</p>

<!-- Upcoming Meetings -->
<h3>Upcoming Meetings:</h3>
<p>
  Mention the dates and times of upcoming meetings related to the discussed topics, if applicable.
</p>

      </div>

      `,
    },
    {
      name: "Article",
      data: `

      <div style={{margin:"10px"}}>
      <!-- Introduction -->
<h3>Introduction</h3>
<p>
  The introduction should engage the reader and provide an overview of the article's main topic. Start with a hook, present the key issue, and state the purpose or thesis of the article.
</p>

<!-- Main Content -->
<h3>Main Content</h3>
<p>
  This section is the heart of your article. Organize the content based on the type of article you're writing:
</p>

<!-- News/Feature Article -->
<h3>News/Feature Article:</h3>
<p>
  Provide relevant facts, details, quotes, and anecdotes to present the story or topic.
</p>

<!-- Opinion/Editorial Article -->
<h3>Opinion/Editorial Article:</h3>
<p>
  Present your opinion, supported by logical reasoning, evidence, and examples.
</p>

<!-- Review Article -->
<h3>Review Article:</h3>
<p>
  Evaluate the subject of the review objectively, discussing its strengths, weaknesses, and overall quality.
</p>

<!-- Research/How-To Article -->
<h3>Research/How-To Article:</h3>
<p>
  Share research findings, instructions, tips, or information on the chosen topic.
</p>

<!-- Interview/Profile Article -->
<h3>Interview/Profile Article:</h3>
<p>
  Share insights from the interviewee or profiled individual, focusing on their experiences, expertise, and perspectives.
</p>

<!-- Conclusion -->
<h3>Conclusion</h3>
<p>
  Summarize the main points of the article and reiterate its significance. Conclude with a thought-provoking statement, a call to action, or a reflection on the topic discussed.
</p>

<!-- Additional Sections (Optional) -->
<h3>Additional Sections (Optional)</h3>
<p>
  Depending on the article type, you might include additional sections such as:
</p>

<!-- References/Citations -->
<h3>References/Citations:</h3>
<p>
  List sources cited or referenced in the article.
</p>

<!-- Author Bio -->
<h3>Author Bio:</h3>
<p>
  Provide a brief biography of the author, including relevant credentials.
</p>

<!-- Visuals -->
<h3>Visuals:</h3>
<p>
  Include images, graphs, charts, or infographics to enhance the content.
</p>

      </div>
      `,
    },
    {
      name: "Blog",
      data: `

      <div style={{margin:"10px"}}>

      <h3>The Blog Post</h3>
      <p>
        This is a classic blog post template, often known as the 'Listicle'. It usually comprises a list of anywhere between 10–30 items that have a reason to be listed (such as tips, techniques, myths, strategies, etc. This type of list is usually used for displaying non-chronological information.
      </p>

      <!-- To use this template -->
      <h3>To use this template:</h3>
      <p>
        Your title should be numbered for the number of items listed in the article. There must be a specific benefit or purpose for your article to make it compelling. Your title should be attention-grabbing. Possible examples:
      </p>

      <!-- Title Examples -->
      <ul>
        <li>'X Important Tips to Achieve [Desired Outcome]'</li>
        <li>
          'X Reasons Why [Problem] Still Persists Despite All Your Attempts'
        </li>
        <li>'X Myths You Need to Stop Believing'</li>
      </ul>

      <!-- Introduction -->
      <h3>Introduction</h3>
      <p>
        Your article should begin by establishing trust with the reader by introducing the problem the reader has and proving the benefit the reader will get from reading your article. Your introduction should be as short as possible. It is advised to include a linked table of contents with jump links so readers can skip right to the tip that interests them if they would like to.
      </p>

      <!-- Subheadings -->
      <h3>Subheadings</h3>
      <p>
        These are important to give readers an overview of what that specific section is about. They also break up your content into manageable chunks. Subheadings should be descriptive and reveal a clear benefit. This will boost the perceived value of each section to help grab readers’ attention to read the section. It is up to you to choose whether or not to number your subheadings. Subheadings should be in head level 2 format.
      </p>

      <!-- Action Items -->
      <h3>Action Items</h3>
      <p>
        Action items are sometimes overlooked in how important they can be. These are the steps a reader will have to take to complete or achieve each item on your list. Including action items is simple: just include the step-by-step information to help readers follow your steps. Often it is helpful to include photos or video visuals.
      </p>

      <!-- Conclusion -->
      <h3>Conclusion</h3>
      <p>
        It is important to wrap up your blog post. You can decide how you want to do this, but most lists end by listing a few more final tips. Your conclusion should leave readers wanting to actually use the information they have received from your blog. You can also encourage them to interact with your post, such as liking, sharing, and commenting.
      </p>

      </div>
      `,
    },
    {
      name: "Appendix",
      data: `
      <div style={{ margin: "50px", backgroundColor: "violet" }}>


      <!-- Appendix A: Protocol -->
      <h3>Appendix A: Protocol</h3>
      <p>
        This example shows how you could format a protocol for your research paper, thesis, or dissertation.
      </p>

      <!-- Materials -->
      <h3>Materials</h3>
      <p>
        The materials for this study can be subdivided into five different types:
      </p>
      <ol>
        <li>Sustained vowel [a:] by COPD speakers during exacerbation;</li>
        <li>Sustained vowel [a:] by COPD speakers during stable COPD;</li>
        <li>Storytelling of ‘The King’ by COPD speakers during exacerbation;</li>
        <li>Storytelling of ‘The King’ by COPD speakers in stable condition;</li>
        <li>Storytelling of ‘Mary and Adam’ by healthy speakers.</li>
      </ol>

      <!-- Type 1: Sustained vowels -->
      <h3>Type 1: Sustained vowels</h3>
      <p>
        The sustained vowels were recorded shortly before or after reading aloud. The King. The vowels were isolated and saved as a separate recording, but this type of speech did not require further annotation before analysis.</p>
        <h3>Type 1-4: Storytelling of COPD speakers and healthy speakers</h3>
      <p>
        Speech types 1-4 were prepared and annotated following the same steps:
      </p>
      <ul>
        <li>
          Each file was clipped to remove the instructions preceding the reading task and the commentary after the reading task.
        </li>
        <li>
          The files were then converted using Praat, changing the sample size from 44 kHz to 16 kHz to prepare the files for forced alignment.
        </li>
        <li>
          The transcript of each file was added in the first interval tier ‘transcript’ to prepare the files for forced alignment.
        </li>
        <li>
          Each file was processed using the forced aligner according to its manual (Xue, De Reus, & Merkus, 2019; see Appendix D), creating two additional interval tiers ‘wordsegmentation’ and ‘phoneticsegmentation’ containing the segmentations of the transcripts on word and phoneme level (in SAMPA).
        </li>
        <li>
          These segmentations on both levels were then manually checked and corrected.
        </li>
        <li>
          After finalizing the segmentation process, three more tiers were manually added to each file for the annotation process. The first (interval) tier ‘respiratory’ was added for respiratory-related annotations, such as ‘inhalation’, ‘exhalation’, ‘pause’. This way, information about the respiratory pattern could be obtained.
        </li>
        <li>
          The second (point) tier ‘speakernoise’ was added for voice quality-related annotations, such as ‘cough’, ‘creaky’, ‘slimy’, to obtain information regarding the voice quality of the speaker. A point tier was preferred over an interval tier because the study focused on the number of occurrences.
        </li>
        <li>
          The third (interval) tier ‘commentary’ was added to clarify the speaker noises or to keep a record of additional observations. The respiratory tier and the speakernoise tier were annotated separately.
        </li>
        <li>
          The first tier to be annotated was the respiratory tier. Each silence interval was studied to determine if the speaker was inhaling (in), exhaling (ex), or if there was an audible pause (p). This way, the transcript could be subdivided into different ‘breathing groups’. The commentary tier was used to specify the annotations.
        </li>
        <li>
The second tier to be annotated was the speakernoise tier. The fragment was replayed to obtain information about the condition of the voice. Audible disturbances, such as hoarseness, creakiness, and sliminess of the voice, were addressed using the speakernoise tier to indicate the occurrence, and the commentary tier to describe the nature of the disturbance.
        </li>
        <li>
          The fragment was then replayed a final time to check the annotations.
        </li>
      </ul>

      <!-- Appendix B: Survey Questions -->
      <h2>Appendix B: Survey Questions</h2>
      <p>
        This example shows how you could format survey questions for your research paper, thesis, or dissertation.
      </p>

      <!-- General questions -->
      <h3>General questions</h3>
      <ol>
        <li>What is your age?</li>
        <li>
          What is the gender you identify with?
          <ul>
          <li></li>
            <li>a) Female</li>
            <li>b) Male</li>
            <li>c) Non-binary</li>
            <li>d) Other</li>
            <li>e) Don’t want to say</li>
          </ul>
        </li>
        <li>
          What is the highest degree or level of school you have completed? If currently enrolled, the highest degree received.
          <ul>
          <li></li>
            <li>a) ...</li>
            <li>b) ....</li>
            <li>c) ...</li>
          </ul>
        </li>
      </ol>


      <!-- Appendix C: Interview Transcript 1 -->
      <h2>Appendix C: Interview Transcript 1</h2>
      <p>
        Interviewer: Thank you very much for your time today and for agreeing to participate in this interview. May I have your consent to video-record?
      </p>
      <p>Participant 1: Yes.</p>
      <p>Interviewer: Great, thank you. I’ll begin the recording now.</p>
      <p>Participant 1: Sounds good.</p>
      <p>
        Interviewer: Okay, we’re ready to get started. My first question is about what you would say your motivation was when you first decided to volunteer for the Army.
      </p>
      <p>
        Participant 1: I wouldn’t say I had motivation, I was against the war. I was drafted, which meant that I had to go regardless of if I wanted to. I had recently gotten married to my first wife and was enjoying helping my dad out at the family hardware store, but when my number got called up I had to go.
      </p>

      <!-- Appendix C: Interview Transcript 2 -->
      <h2>Appendix C: Interview Transcript 2</h2>
      <p>
        Interviewer: Thank you very much for your time today and for agreeing to participate in this interview. May I have your consent to video-record?
      </p>
      <p>Participant 2: I would prefer that you only audio-recorded.</p>
      <p>
        Interviewer: Okay, no problem, look, you can see here I am just pressing audio, not video.
      </p>
      <p>Participant 2: I appreciate that.</p>
      <p>
        Interviewer: Okay, so let’s get started. My first question is about what you would say your motivation was when you first decided to join the Army.
      </p>
      <p>
        Participant 2: Well, the war in Vietnam had just started, and my twin brother and I were freshmen in college at the time. We decided to join on our own terms, rather than wait to be drafted. He ended up in the Airborne Division, while I ended up in the Cavalry Division.
      </p>
      </div>
      `,
    },
  ];

  // Initialize speech recognition
  useEffect(() => {
    const SpeechRecognitionAPI =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognitionAPI) {
      console.warn("Speech recognition is not supported in this browser.");
      return;
    }

    const recognition = new SpeechRecognitionAPI();

    recognition.continuous = true;
    recognition.interimResults = false;
    recognition.lang = "en-US";

    recognition.onresult = (event) => {
      const transcript = event.results[event.results.length - 1][0].transcript;
      setTranscriptBuffer((prev) => prev + " " + transcript);
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
      if (event.error === "not-allowed") {
        toast.error(
          "Microphone access denied. Please allow microphone access.",
        );
      } else if (event.error === "no-speech") {
        toast.warn("No speech detected. Please try again.");
      }
      setIsRecording(false);
    };

    recognition.onend = () => {
      if (isRecording) {
        // Process any remaining transcript buffer
        if (transcriptBuffer.trim()) {
          handleSpeechInput(transcriptBuffer);
        }
        setTranscriptBuffer("");
        setIsRecording(false);
      }
    };

    recognitionRef.current = recognition;

    return () => {
      if (recognitionRef.current) {
        try {
          recognitionRef.current.stop();
        } catch (e) {
          // Ignore stop errors on unmount
        }
      }
    };
  }, []);

  // Process transcript buffer when it changes
  useEffect(() => {
    if (transcriptBuffer && !isRecording) {
      handleSpeechInput(transcriptBuffer);
    }
  }, [transcriptBuffer, isRecording]);

  useEffect(() => {
    const checkBotStatus = () => {
      const email =
        sessionStorage.getItem("currentUserEmail") ||
        localStorage.getItem("currentUserEmail");

      if (!email) {
        setShowCoAuthorBot(false);
        return;
      }

      const botStatus = getBotAccess("couthor"); // use exact key
      setShowCoAuthorBot(botStatus === true);
    };

    checkBotStatus();

    const handleBotAccessChange = (event) => {
      const { botType, status } = event.detail;

      if (botType === "couthor") {
        setShowCoAuthorBot(status === true);
      }
    };

    window.addEventListener("botAccessChanged", handleBotAccessChange);

    return () => {
      window.removeEventListener("botAccessChanged", handleBotAccessChange);
    };
  }, [userDetails]);

  // for access
  useEffect(() => {
    const accessMap = {
      Documents: accessToDocumentScreen,
      grammerChaeck: accessToGrammarCheckScreen,
      coAuthor: accessToCoAuthorScreen,
      blogs: accessToBlogScreen,
      Tags: accessToTagsScreen,
    };
    console.log(
      "accessToGrammarCheckScreen",
      accessToGrammarCheckScreen,
      currentNavItem,
    );
    // if currentNavItem exists in accessMap and user doesn’t have access
    if (accessMap[currentNavItem] === false) {
      setSubReqOpen(true);
    }
  }, [
    currentNavItem,
    accessToDocumentScreen,
    accessToGrammarCheckScreen,
    accessToCoAuthorScreen,
    accessToBlogScreen,
    accessToTagsScreen,
  ]);

  useEffect(() => {
    // 1️⃣ Initialization effects that run once on mount
    const handleResize = () => setWindowWidth(window.innerWidth);
    const updateTheme = () => {
      const theme = localStorage.getItem("ThemeSwitch");
      setIsDarkMode(theme === "true");
    };
    // setup listeners
    window.addEventListener("resize", handleResize);
    window.addEventListener("storage", updateTheme);
    updateTheme();
    // override localStorage.setItem for live theme sync
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "ThemeSwitch") updateTheme();
    };
    checkIgnoredSentence();
    dispatch(closeLowerModalAndOpenLeftNavbar());
    // cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("storage", updateTheme);
      localStorage.setItem = originalSetItem;
      if (isRecording && recognitionRef.current) {
        try {
          recognitionRef.current.stop();
        } catch (e) {
          // Ignore stop errors
        }
      }
    };
  }, []);

  useEffect(() => setFolderId(sharedFolderId), [sharedFolderId]);
  useEffect(
    () => setMountedFromUpload(uploadDocumentValue),
    [uploadDocumentValue],
  );
  useEffect(
    () => setSharedDocument(sharedDocumentValue),
    [sharedDocumentValue],
  );

  useEffect(() => {
    console.log("useEffectCheck_", location.state, docId, mountedFromUpload);
    if (location.state?.blogContent) {
      setEditorContentUpload(location.state.blogContent);
      setDocName(location.state.blogName);
      setTags(location.state.blogTags);
    }
    // else if (location.state && !docId ) {
    //   const { fileContent } = location.state;
    //   setEditorContentUpload(fileContent);
    // }
    else if (location.state && mountedFromUpload && !docId) {
      const { fileContent, fileName } = location.state;
      let finalFileName = fileName.substring(0, fileName.lastIndexOf("."));
      setDocName(finalFileName);
      // setEditorContent(fileContent);
      // setEditorValue(
      //   (fileContent || "")
      //     .replace(/<br\s*\/?>/gi, "\n")
      //     .replace(/<\/p>\s*<p>/gi, "\n")
      //     .replace(/<[^>]*>/g, "")
      //     .replace(/&nbsp;/g, " ")
      //     .trim(),
      // );
      setTimeout(() => {
        if (editorRef.current) {
          editorRef.current.innerHTML = fileContent || "";
          let text = editorRef.current.innerText;
          console.log("text_", text);
          let wordCount = 0;
          wordCount = text.split(/\s+/).length;
          setIsTyping(true);
          setEditorValue(text);
          setTotalWords(wordCount);
          setEditorContent(editorRef.current.innerHTML);
        }
      }, 0);
      setMountedFromUpload(false);
    }
  }, [location.state, docId, mountedFromUpload]);

  useEffect(() => {
    console.log("templateCheck_", selectedTemplateName);
    if (!selectedTemplateName || !editorRef.current) return;
    const selectedTemplate = templateData.find(
      (data) => data.name === selectedTemplateName,
    );
    if (!selectedTemplate) return;
    setTimeout(() => {
      if (editorRef.current) {
        editorRef.current.innerHTML = selectedTemplate.data;
        let text = editorRef.current.innerText;
        let wordCount = 0;
        wordCount = text.split(/\s+/).length;
        setIsTyping(true);
        setEditorValue(text);
        setTotalWords(wordCount);
        setEditorContent(editorRef.current.innerHTML);
      }
    }, 0);
    setTimeout(() => focusEditorAtEnd(), 0);
  }, [selectedTemplateName]);

  const focusEditorAtEnd = () => {
    const editor = editorRef.current;
    editor.focus();
    const range = document.createRange();
    const sel = window.getSelection();
    range.selectNodeContents(editor);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
  };

  useEffect(() => {
    if (docId) getDocById(docId);
  }, [docId]);

  useEffect(() => {
    handleMenuItemClick(viewOnlyAccess ? "Viewing" : "Editor View");
  }, [viewOnlyAccess]);

  useEffect(() => {
    const logChanges = async () => {
      if (docCurrentContent && docInitialContent && !isModifiedDoc) {
        if (docCurrentContent !== docInitialContent) {
          try {
            const data = {
              userId: sessionStorage.getItem("userId"),
              organizationId: sessionStorage.getItem("organizationId"),
              actionType: "editDoc",
            };
            const addLogs = await addUserLogs(data);
            if (addLogs.status === 200) setIsModifiedDoc(true);
            else toast.error(addLogs.message);
          } catch (error) {
            toast.error("Failed to add logs");
            console.error("Error logging user activity:", error);
          }
        }
      }
    };
    logChanges();
  }, [docCurrentContent, docInitialContent, isModifiedDoc]);

  useEffect(() => {
    console.log("docName_", docName, docId, newDocId, updateDocName);
    if (docName && docId == "") {
      fetchData();
    }
    if (updateDocName) {
      console.log("docName_", docName);
      const socketData = {
        documentName: docName,
        documentId: docId !== undefined ? docId : newDocId,
        onlyDocumentContent: editorRef.current.innerHTML,
        // onlyDocumentContentText: textData,
        // formattedDocumentContent: editorContent,
        folder: folderId ? folderId : null,
        tags: tags,
        //imageUrl: image,
      };
      autoSaveContent(socketData, false);
    }
  }, [docName]);

  useEffect(() => {
    console.log("update_editorValue", editorValue, docId, newDocId);
    const typingTimer = setTimeout(() => {
      if (docId == "" && docName == "") {
        console.log("update_editorValue", editorValue);
        if (editorValue?.trim()?.split(/\s+/).length > 2) {
          let proName = editorValue
            ?.trim()
            ?.split(/\s+/)
            ?.slice(0, 2)
            ?.join(" ");
          // setFinalprojectname(proName);
          setDocName(proName);
        }
      }
      handleStoppedTyping();
    }, 2000);

    return () => clearTimeout(typingTimer);
  }, [editorValue, newDocId]);

  useEffect(() => {
    const handleSelectionChange = () => {
      const selectedText = window.getSelection().toString();
      if (selectedText) dispatch(selectCoauthorContent(selectedText));
      else dispatch(clearCoauthorContent());
    };
    document.addEventListener("selectionchange", handleSelectionChange);
    return () =>
      document.removeEventListener("selectionchange", handleSelectionChange);
  }, [dispatch]);

  const checkIgnoredSentence = async () => {
    try {
      const userId = sessionStorage.getItem("userId");
      let id = userId;
      const response = await documentService.getIgnoredSuggestions(id);
      if (response.getPhrases.length > 0) {
        setIgnoredSuggestions(response.getPhrases);
      }
    } catch (error) {
      console.log("Error in checking ignored suggestion.");
    }
  };

  let grammarCheckArray = [];
  let finalArray = [];

  const closeDownloadModal = () => {
    setIsDownloadModalOpen(false);
  };

  const openDownloadModal = () => {
    setIsDownloadModalOpen(true);
  };

  const setEditorContentUpload = (textContent) => {
    if (editorRef.current) {
      const setContent = editorRef.current;
      setContent.setEditorValue(textContent);
    }
  };

  const handleTranslateClick = () => {
    let edtiortext = editorRef.current.innerText;
    if (edtiortext !== "") {
      dispatch(closeRightModal());
      setIsSuggestion(false);
      setShowTranslateModel(true);
      setShowTranslator1(true);
      setTrackIsModalOpen(true);
      dispatch(openLowerModalAndCloseLeftNavbar());
    } else {
      toast.warn("Please enter some text");
    }

    setShowSummariser1(false);
    setShowParaphraser1(false);
  };

  const handleCloseTranslate = () => {
    setShowTranslateModel(false);
    setTrackIsModalOpen(false);
    dispatch(
      mobileView ? closeLowerModal() : closeLowerModalAndOpenLeftNavbar(),
    );
    if (isFullSize) {
      dispatch(fullSizeEditor());
      dispatch(closeLeftNavbar());
    }
  };

  const getDocById = async (docId) => {
    console.log("CurrentText_", docId);
    try {
      const response = await documentService.getDocumentbyId(docId);
      if (response.status === 200) {
        const {
          documentName,
          onlyDocumentContent,
          readOnly,
          status,
          reviewStatus,
          formattedDocumentContent,
          tags,
        } = response.data.document;
        setTags(tags);
        setViewOnlyAccess(readOnly);
        if (readOnly) {
          setSelectedEditOption(false);
        } else {
          setSelectedEditOption(true);
        }
        if (reviewStatus == true) {
          setClickSubmitForReview(true);
        }
        if (documentName) {
          setEditorValue(response.data.documentBody);
          console.log("docNAme_", documentName);
          setDocName(documentName);
          if (editorRef.current) {
            let wordCount = 0;
            wordCount = response.data.documentBody
              .split(/\s+/)
              .filter((word) => word.length > 0).length;
            setTotalWords(wordCount);
            editorRef.current.innerHTML = onlyDocumentContent;
          }
          setIsTyping(false);
        } else {
          console.error(
            "Error: Document name or content is missing in the response data",
            response.data,
          );
        }
      } else {
        console.error("Error fetching data:", response.message);
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }
  };

  // Handle word limit dialog close (NEW)
  const handleWordLimitDialogClose = () => {
    setWordLimitDialogOpen(false);
    setWordLimitExceeded(false);
  };

  const handleSummariserClick = async () => {
    // Check if word count exceeds limit (NEW)
    if (totalWords > 2500) {
      setWordLimitDialogOpen(true);
      setWordLimitExceeded(true);
      return;
    }

    // const checkailimit = await checkAIRequestLimit(userID);
    // console.log(checkailimit, "_checkailimit");
    // if (checkailimit == false) {
    //   toast.warn("AI request limit reached.");
    //   return;
    // }
    // let edtiortext = editorRef.current.innerText
    // setEditorValue(edtiortext)
    if (editorValue !== "") {
      dispatch(closeRightModal());
      setIsSuggestion(false);
      setShowTranslateModel(true);
      setShowSummariser1(true);
      setTrackIsModalOpen(true);
      dispatch(openLowerModalAndCloseLeftNavbar());
      if (callSummarise === false) {
        setCallSummarise(true);
      } else {
        setCallSummarise(false);
      }
    } else {
      toast.warn("Please enter text");
    }
    setShowTranslator1(false);
    setShowParaphraser1(false);
  };

  const handleParaphraseClick = async () => {
    // Check if word count exceeds limit (NEW)
    if (totalWords > 2500) {
      setWordLimitDialogOpen(true);
      setWordLimitExceeded(true);
      return;
    }

    // const checkailimit = await checkAIRequestLimit(userID);
    // console.log(checkailimit, "_checkailimit");
    // if (checkailimit == false) {
    //   toast.warn("AI request limit reached.");
    //   return;
    // }
    // let edtiortext = editorRef.current.innerText
    // setEditorValue(edtiortext)
    if (editorValue !== "") {
      dispatch(closeRightModal());
      setIsSuggestion(false);
      setShowTranslateModel(true);
      setShowParaphraser1(true);
      setTrackIsModalOpen(true);
      dispatch(openLowerModalAndCloseLeftNavbar());
      if (callGrammerCheck === false) {
        setCallGrammerCheck(true);
      } else {
        setCallGrammerCheck(false);
      }
    } else {
      toast.warn("Please enter text");
    }
    setShowTranslator1(false);
    setShowSummariser1(false);
  };

  const handleEditDropdownOpen = (event) => {
    setEditDropdown(event.currentTarget);
  };
  const handleEditDropdownClose = () => {
    setEditDropdown(null);
  };
  const handleMenuItemClick = (option) => {
    handleEditDropdownClose();
    if (option === "Viewing") {
      setSelectedEditOption(false);
      dispatch(closeLeftNavbar());
    } else {
      setSelectedEditOption(true);
      dispatch(openLeftNavbar());
    }
  };

  function handleDeleteFormain() {
    console.log("delete clicl");
    if (editorRef.current) {
      // Access the editor instance using the current property of the ref
      // const cleareditor = editorRef.current;
      // editorRef.current.innerHTML = "";
      // Clear the content using the setContent method of the editor instance
      // cleareditor.setEditorValue("");
      editorRef.current.focus();
      document.execCommand("selectAll", false, null);
      document.execCommand("delete", false, null);
    }
    setEditorContent("");
    setEditorValue("");
    setSentenceResult([]);
    setNewSentences([]);
    setIsSuggestion(false);
    setTranscriptBuffer("");
    dispatch(resetTemplateName(""));
  }

  const handleDownloadFormain = () => {
    const htmlString = `<!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
    </head>
    <body>
        <h3>${docName}</h3>
        <hr/>
        ${editorContent}
    </body>
    </html>`;

    asBlob(htmlString).then((docx) => {
      saveAs(docx, `${docName}.docx`);
    });
  };

  function handleCopyFormain() {
    let sentence;
    if (editorRef.current) {
      sentence = editorRef.current.innerText;
    }
    if (sentence == "") {
      toast.warn(`You don't have text, to copy`);
      return;
    }
    navigator.clipboard.writeText(sentence).then(
      function () {
        console.log("Async: Copying to clipboard was successful!");
        if (sentence) toast.info("Your text Copied!");
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      },
    );
  }

  // Delete function for summarizer  editor
  const handleDeleteInSummarizer = (data) => {
    if (data === true) {
      setSecondaryEditorStateSummarizer(EditorState.createEmpty());
    }
  };

  // ---- upload file ----
  const handleWordCountExceed = () => {
    if (!maxCountDisplayed) {
      toast.warn("Word count exceeded than 2500");
      setMaxCountDisplayed(true);
    }
  };

  const convertTextToHtml = (text) => {
    // Split the text into paragraphs based on line breaks
    const paragraphs = text.split("\n");
    // Map each paragraph to wrap it with <p> tags and handle line breaks
    const htmlContent = paragraphs.map((paragraph) => {
      // Replace consecutive line breaks with <br> tags within the paragraph
      const paragraphWithBreaks = paragraph.replace(/\n{2,}/g, "<br><br>");
      // Wrap the paragraph with <p> tags
      return `<p>${paragraphWithBreaks}</p>`;
    });
    // Join the paragraphs into a single HTML string
    return htmlContent.join("");
  };

  const handleFileChange = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".docx,.txt";
    fileInput.style.display = "none";

    fileInput.addEventListener("change", async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      if (file.type === "application/pdf") {
        toast.warn("PDF is not supported.");
        return;
      }

      // 📌 Handle TXT Upload
      if (file.name.endsWith(".txt")) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const text = e.target.result;
          // convert text to HTML format
          editorRef.current.innerHTML = text.replace(/\n/g, "<br>");
          const htmlContent = editorRef.current.innerHTML;
          setEditorContent(htmlContent); // store HTML content
          setEditorValue(editorRef.current.innerText); // plain text value if needed
          console.log("htmlContent_", htmlContent);
        };

        reader.readAsText(file);
        return;
      }

      // 📌 Handle DOCX Upload + IMAGES 🚀
      if (file.name.endsWith(".docx")) {
        try {
          const arrayBuffer = await file.arrayBuffer();

          const result = await mammoth.convertToHtml({
            arrayBuffer,
            convertImage: mammoth.images.inline(async (image) => {
              const imageBuffer = await image.read();
              return {
                src: `data:${image.contentType};base64,${imageBuffer.toString(
                  "base64",
                )}`,
              };
            }),
          });

          const htmlContent = result.value;
          setEditorContent(htmlContent);
          console.log("textValue_", editorRef.current.innerText);
          setEditorValue(editorRef.current.innerText);
          editorRef.current.innerHTML = htmlContent;
          // focusEditorAtEnd();
        } catch (err) {
          console.error("DOCX Error:", err);
          toast.error("Failed to read DOCX file");
        }
        return;
      }

      toast.warning("Upload only .txt or .docx files");
    });

    document.body.appendChild(fileInput);
    fileInput.click();
    document.body.removeChild(fileInput);
  };

  ////////////////    UPDATED MIC FUNCTIONALITY   /////////////////////////////////////
  const handleMicClick = () => {
    if (accessToMic == false) {
      setSubReqOpen(true);
      setIsFeatureInside(true);
      return;
    }

    if (!recognitionRef.current) {
      toast.error("Speech recognition is not supported by your browser.");
      return;
    }

    if (isRecording) {
      // Stop recording
      try {
        recognitionRef.current.stop();
      } catch (error) {
        console.error("Error stopping speech recognition:", error);
      }
      setIsRecording(false);
    } else {
      // Start recording
      try {
        setTranscriptBuffer(""); // Clear buffer
        recognitionRef.current.start();
        setIsRecording(true);
        toast.info("Listening... Speak now");
      } catch (error) {
        console.error("Error starting speech recognition:", error);
        toast.error("Failed to start speech recognition. Please try again.");
      }
    }
  };

  const handleSpeechInput = (input) => {
    console.log("inputMic_", input);
    if (input.trim() !== "") {
      if (editorRef.current) {
        // Focus the editor
        editorRef.current.focus();

        // Get current content
        const currentContent = editorRef.current.innerHTML || "";

        // Add space if content exists
        const separator =
          currentContent && !currentContent.endsWith(" ") ? " " : "";

        // Append new speech input
        const updatedContent = currentContent + separator + input;

        // Update editor
        editorRef.current.innerHTML = updatedContent;

        // Update state
        setEditorContent(updatedContent);
        setEditorValue(
          editorRef.current.innerText || updatedContent.replace(/<[^>]*>/g, ""),
        );

        // Move cursor to end
        focusEditorAtEnd();

        toast.success("Speech added to editor");
      }
    }
  };
  ////////////////  UPDATED MIC FUNCTIONALITY END /////////////////////////////////////

  const handleTextEditor = (data, wordsCount, characterCount) => {
    // const textData = `{\"blocks\":[{\"key\":\"9ukr0\",\"text\":\"${editorContent}\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}`;
    // setCircularLoader(false);
    console.log(
      "editorData_",
      data,
      wordsCount,
      characterCount,
      docId,
      newDocId,
    );
    const socketData = {
      documentName: docName,
      documentId: docId !== "" ? docId : newDocId,
      onlyDocumentContent: editorContent,
      wordsCount,
      characterCount,
      folder: folderId ? folderId : null,
      tags: tags,
      //imageUrl: image,
    };
    autoSaveContent(socketData, true);
  };

  const autoSaveContent = async (data, IsGC) => {
    console.log("inside_autosave", data, accessToEdit);
    try {
      if (!accessToEdit) {
        return;
      }
      if (
        data.onlyDocumentContent == "" ||
        data.documentName == "" ||
        data.documentId == ""
      ) {
        setNewSentences([]);
        return;
      }
      const response = await documentService.autoSaveDocument(data);
      if (response.status === 200) {
        //toast.success("Document Saved");
        setUpdateDocName(false);
        setMountedFromUpload(false);
        setDocCurrentContent(data.onlyDocumentContent);
        console.log("editorValue_", editorValue);
        if (editorValue !== "") {
          if (isCoAuthor) {
            if (clickSubmitForReview) {
              return;
            }
          }
          console.log("isGrammarCheck_", isGrammarCheck);
          if (isGrammarCheck && IsGC) {
            grammarCheckClick();
          }
        }
      }
    } catch (error) {
      console.error("Error occurred during auto save:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChildStateChange = (newChildState) => {
    // Handle the child state change in the parent component

    console.log("newChildState_", newChildState);
    try {
      if (newChildState) {
        editorRef.current.innerText = newChildState;
      } else {
        // Handle the case when newChildState is null or undefined
        setEditorContent("");
        setEditorValue("");
      }
    } catch (error) {
      console.error("Error handling child state change:", error);
    }
  };

  const passNametoCoNewProject = (name) => {
    if (name) {
      // Concatenate the name with existing editor content
      const updatedContent = editorContent + ` - ${name}`;
      // setEditorContent(updatedContent)
      setEditorValue(updatedContent);
      setEditorContentUpload(updatedContent);
    }
  };

  const fetchData = async () => {
    try {
      const data = {
        documentName: `${docName}`,
        documentType: "document",
      };
      const documentId = await documentService.saveDocs(data);
      const data1 = {
        userId: sessionStorage.getItem("userId"),
        organizationId: sessionStorage.getItem("organizationId"),
        actionType: "newDoc",
      };

      const addLogs = await addUserLogs(data1);
      if (addLogs.status !== 200) {
        toast.error(addLogs.message);
      }
      // Set apiCalled to true to prevent further API calls
      console.log("document_ID", documentId);
      setCircularLoader(true);
      setNewDocId(documentId);
      setDocApiCalled(true);
      handleTagGenerator(documentId, "document");
      setCircularLoader(true);
    } catch (error) {
      // Handle error
      console.error("Error occurred:", error);
    }
  };

  // Function to execute after user stops typing
  const handleStoppedTyping = () => {
    // setIsTyping(false);
    // setLoading(true)
    console.log("handleEditorChange_2");
    // const currentInputText = editorValue;
    console.log("Parachanges_", editorValue, isTyping);

    if (editorValue === "" || !isTyping) {
      // setIsSuggestion(false);
      // setSentenceResult([]);
      setNewSentences([]);
      return;
    } else {
      const [wordsCount, characterCount] = strCount(editorValue);
      // let convertRaw = convertToRaw(editorContent);
      handleTextEditor(editorValue, wordsCount, characterCount);
    }
  };

  const handleFullSizeEditor = () => {
    dispatch(fullSizeEditor());
    dispatch(closeLeftNavbar());
  };
  const handleNormalSizeEditor = () => {
    dispatch(normalSizeEditor());
    dispatch(openLeftNavbar());
  };

  const grammarCheckClick = async () => {
    // Check if word count exceeds limit (NEW)
    if (totalWords > 2500) {
      setWordLimitDialogOpen(true);
      setWordLimitExceeded(true);
      return;
    }

    // Switch from lower/right tools to grammar suggestion panel cleanly.
    dispatch(closeLowerModal());
    dispatch(closeRightModal());
    setShowTranslateModel(false);
    setShowTranslator1(false);
    setShowSummariser1(false);
    setShowParaphraser1(false);
    setTrackIsModalOpen(false);
    setIsSuggestion(true);

    // const checkailimit = await checkAIRequestLimit(userID);
    // console.log(checkailimit, "_checkailimit", editorContent);
    // if (checkailimit == false) {
    //   toast.warn("AI request limit reached.");
    //   return;
    // }
    let filterArray = [];
    let filtersentence;
    let sentencesArray = editorValue
      // Remove extra dots at the end of sentences (e.g., "sentence.." → "sentence.")
      .replace(/\.+/g, ".")
      // Split into sentences
      .split(".")
      // Remove empty strings
      .filter((s) => s.trim())
      // Add a dot only if missing
      .map((s) => {
        const trimmed = s.trim();
        return trimmed.endsWith(".") ? trimmed : trimmed + ".";
      });
    console.log("textContent_", newSentences, sentencesArray);

    if (newSentences.length > 0) {
      filterArray = sentencesArray.filter(
        (item) => !newSentences.includes(item),
      );
      if (filterArray.length == 0) {
        // if (sentenceResult.length == 0) {
        //   handleCheckGrammarFluency(editorContent, filterArray);
        // } else {
        //   handleCheckGrammarFluency(editorContent, newSentences);
        // }
        // setIsAllFix(true)
        // setIsSuggestion(false)
        setLoading(false);
        return;
      }
      filtersentence = filterArray.filter((item) => {
        return item !== "";
      });
    } else {
      filtersentence = sentencesArray.filter((item) => {
        return item !== "";
      });
    }

    // handleCheckGrammarFluency(editorContent, filtersentence);

    console.log(filtersentence, filtersentence.length, "kokoo");

    // for (let i = 0; i < filtersentence.length; i++) {
    //   let firstSentence = filtersentence.slice(i, i + 2);
    //   console.log(
    //     "filtersentence",
    //     filtersentence.length,
    //     i,
    //     filtersentence[i]
    //   );
    //   // let mergesentence = (firstSentence.length > 1) ? firstSentence[0] + '.' + firstSentence[1] + '.' : firstSentence[0] + '.' + "This is the end of the content"
    //   // if(sentencesArray.length - 1 == i){
    //   //    filtersentence =firstSentence[0] + '.' + "This is the end of the content"
    //   // }
    //   finalArray.push(filtersentence[i]);
    // }
    // console.log(finalArray, "kokoo");

    // if (isAllFix) {
    // for (const [i, item] of filtersentence.entries()) {
    //   await checkGrammarWords(item, filtersentence.length);
    // }
    await checkGrammarWords(editorValue, 0);

    // }
  };

  const ocrCheck = async () => {
    // const checkailimit = await checkAIRequestLimit(userID);
    // console.log(checkailimit, "_checkailimit");
    // if (checkailimit == false) {
    //   toast.warn("AI request limit reached.");
    //   return;
    // }
    setLoading(true);

    // Perform OCR check and get the response
    const response = await checkOCR(editorContent);

    if (response.status === 200) {
      const data = {
        userId: sessionStorage.getItem("userId"),
        organizationId: sessionStorage.getItem("organizationId"),
        actionType: "OCR",
      };
      const addLogs = await addUserLogs(data);
      if (addLogs.status !== 200) {
        toast.error(addLogs.message);
      }
      // Extract the list of OCR results
      const { results } = response;

      // Create a temporary DOM to manipulate the editor content
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = editorContent;

      // Find all the image tags in the editor content
      const images = tempDiv.querySelectorAll("img");

      // Loop through each image in the editor content
      images.forEach((img) => {
        // Get the src of the current image
        const imgSrc = img.getAttribute("src");

        // Find the matching OCR result based on the image src
        const result = results.find((res) => res.src === imgSrc);

        if (result && result.ocrResult) {
          // Prepare the OCR result by replacing `/n` with `<br>` and removing `\"`
          const formattedOCRResult = result.ocrResult
            .replace(/\n/g, "<br>")
            .replace(/\\"/g, '"');

          // Create a new p tag to insert the OCR result below the image
          const pTag = document.createElement("p");
          pTag.innerHTML = formattedOCRResult;

          // Insert the p tag after the image
          img.insertAdjacentElement("afterend", pTag);
        }
      });

      // Update the editor with the modified HTML content
      setEditorContentUpload(tempDiv.innerHTML);
    } else if (response.status === 400) {
      toast.error(response.message);
    } else {
      toast.error("OCR extraction failed");
    }
    setLoading(false);
  };

  const handleTagGenerator = async (id, type) => {
    let payload = {
      documentId: id,
      documentType: type,
    };
    const response = await documentService.generateAutoTag(payload);
    console.log("tagresponse_", response);
  };

  const editorStyle = {
    transition: "width 0.3s",
    maxWidth: "100%",
    width: !mobileView
      ? !selectedEditOption
        ? !selectedEditOption
          ? "120%"
          : "100%"
        : (trackIsModelOpen && rightModalOpen) || lowerModelOpen
          ? isSuggestion
            ? "100%"
            : "100%"
          : "100%"
      : "100%",
    // height: !selectedEditOption ? "500px" : "100%",
    // minHeight: "320px",
    // border: "1px solid red"
  };

  const handleBackButton = () => {
    if (selectedEditOption || sharedDocument) {
      if (isCoAuthor) {
        history.push("/coauthor");
      } else {
        history.goBack();
      }
    }
    dispatch(resetTemplateName(""));
    dispatch(openLeftNavbar());
    handleMenuItemClick("Editor View");
  };

  const submitForReview = async () => {
    swal({
      title: "Review Document",
      text: "Submit your Document for Review ?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (reviewDoc) => {
      console.log("DocID_", docId);
      if (reviewDoc) {
        let payload = {
          userId: userID,
          id: docId,
        };
        try {
          const response = await reviewDocument(payload);
          if (response.status !== 200) {
            toast.error(response.message);
          } else {
            toast.info(response.message);
            setClickSubmitForReview(true);
          }
          // Perform any additional actions after submission
        } catch (error) {
          console.error("Error submitting for review:", error);
          toast.error("An error occurred while submitting for review");
        }
      }
    });
  };

  const handleChangeEditor = (e) => {
    console.log("inside_editor", e.target.textContent, editorRef);
    // const html = e.target.innerHTML; // rich HTML
    const text = e.target.textContent;
    if (editorRef.current) {
      console.log("handleEditorChange_", editorRef.current.innerText);
      const htmlContent = editorRef.current?.innerHTML || "";
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");

      // Count the number of <img> tags
      const imgTags = doc.getElementsByTagName("img");
      const imgCount = imgTags.length;

      let wordCount = 0;
      wordCount = text.split(/\s+/).filter((word) => word.length > 0).length; // More accurate word count
      const orgName = userDetails?.user?.currentUser?.organizationName;
      setTotalWords(wordCount);
      //  if (wordCount > 2500 && orgName !== "BostonBrooks Advisory") {
      //   // Only show warning if it's actually exceeding the limit
      //   if (!wordLimitDialogOpen && !wordLimitExceeded) {
      //     // toast.warning(
      //     //   `Word count (${wordCount}) exceeds the limit of 2500 words. Please reduce your text to continue with AI features.`,
      //     // );

      //     // Show word limit dialog
      //     setWordLimitDialogOpen(true);
      //     setWordLimitExceeded(true);
      //   }
      // } else {
      //   // Reset the exceeded state if under limit
      //   if (wordCount <= 2500 && wordLimitExceeded) {
      //     setWordLimitExceeded(false);
      //   }
      // }

      if (wordCount > 2500 && orgName !== "BostonBrooks Advisory") {
        if (!wordLimitDialogOpen && !wordLimitExceeded) {
          // toast.warning(
          //   `Word count (${wordCount}) exceeds the limit of 2500 words. Please reduce your text to continue with AI features.`,
          // );
          // Show word limit dialog
          setWordLimitDialogOpen(true);
          setWordLimitExceeded(true);
          return;
        }
        // toast.warning(
        //   "File content limit exceeded. Truncated content to 2500 words.",
        // );
      } else {
        // Update word count and editor content normally if limit not exceeded
        console.log("handleEditorChange_e");
        setIsTyping(true);
        setEditorValue(text);
        setEditorContent(editorRef.current.innerHTML);
        setAcceptAllClicked(false);
      }
    }

    setAcceptAllClicked(false);
  };

  const extractArguments = (data) => {
    let extracted = [];

    if (Array.isArray(data) && data[0]?.function) {
      extracted = data.map((item) => item.function.arguments);
    } else if (data[0]?.message?.tool_calls) {
      extracted = data[0].message.tool_calls.map(
        (item) => item.function.arguments,
      );
    }

    // 🔥 Remove duplicates using errored_text
    const seen = new Set();

    const unique = extracted.filter((item) => {
      const key = item.errored_text?.toLowerCase().trim(); // normalize

      if (seen.has(key)) return false;

      seen.add(key);
      return true;
    });
    return unique;
  };

  const checkGrammarWords = async (inputtext, index) => {
    console.log("grammarResponse_", inputtext);
    // setLoading(true)
    setSuggestionLoader(true);
    let data = {
      text: inputtext,
    };
    // if (index == indexValid) {
    let grammarResponse = await checkGrammar(data);
    console.log("grammarResponse_1", grammarResponse);
    if (grammarResponse?.data == "" || grammarResponse?.data == null) {
      console.log("grammarResponse_2", grammarResponse);
      setSuggestionLoader(false);
      return;
    }

    let responseOutput = grammarResponse?.data[0];
    // // let responseOutput = "\n{\n  \"replacements\": [\n    {\n      \"value\": \"the\",\n      \"phrase\": \"The the\",\n      \"start_position\": 8,\n      \"corrective_text\": \"The\",\n      \"type_of_error\": \"grammatical\",\n      \"justification\": \"Removing redundant use of article 'the'.\"\n    },\n    {\n      \"value\": \"Sun\",\n      \"phrase\": \"sUn\",\n      \"start_position\": 22,\n      \"corrective_text\": \"Sun\",\n      \"type_of_error\": \"spelling\",\n      \"justification\": \"Correct spelling of 'Sun'.\"\n    },\n    {\n      \"value\": \"a\",\n      \"phrase\": \"A beautiful\",\n      \"start_position\": 43,\n      \"corrective_text\": \"a beautiful\",\n      \"type_of_error\": \"grammatical\",\n      \"justification\": \"Adding article 'a' before the adjective 'beautiful'.\"\n    }]}"
    let finaloutput = responseOutput.message.tool_calls;
    console.log("grammarResponse_3", finaloutput);

    let grammarCheckFinal = extractArguments(finaloutput);

    grammarCheckArray.push(finaloutput);
    console.log("grammarResponse_4", grammarCheckArray, grammarCheckFinal);

    if (grammarCheckFinal?.length > 0) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      console.log("grammarResponse_5", grammarCheckFinal);

      setSentenceResult(grammarCheckFinal);
      setSuggestionLoader(false);

      // const data1 = {
      //   userId: sessionStorage.getItem("userId"),
      //   organizationId: sessionStorage.getItem("organizationId"),
      //   actionType: "check grammer",
      // };
      // const addLogs = await addUserLogs(data1);
      // if (addLogs.status !== 200) {
      //   toast.error(addLogs.message);
      // }
    }
  };

  const closeAIAssistant = () => {
    setIsAIOpen(false);
  };

  const handleFormality = (e) => {
    console.log("handleFormality", e.target.id, formality);
    let objID = e.target.id;
    setFormality(objID);
  };

  const handleTone = (e) => {
    console.log("handleTone", e.target.id, tone);
    let objID = e.target.id;
    setTone(objID);
  };

  const handleProfession = (e) => {
    console.log("handleProfession", e);
    let value = e.target.value;
    setProfession(value);
  };

  const updateAIAssistant = () => {
    console.log("updateAIAssistant", formality, tone, profession);
    closeAIAssistant();
  };

  const handleAIReview = () => {
    dispatch(closeLowerModal());
    setShowTranslateModel(false);
    setShowTranslator1(false);
    setShowSummariser1(false);
    setShowParaphraser1(false);
    setshowAireviewContent(true);
    setTrackIsModalOpen(true);
    dispatch(openRightModalAndCloseLeftNavbar());
  };

  const handleSwitchToRightToolPanel = () => {
    dispatch(closeLowerModal());
    setShowTranslateModel(false);
    setShowTranslator1(false);
    setShowSummariser1(false);
    setShowParaphraser1(false);
    setIsSuggestion(false);
    setTrackIsModalOpen(true);
  };

  // const handleCloseModal = () => {
  //   setshowAireviewContent(false);
  //   dispatch(
  //     mobileView ? closeRightModal() : closeRightModalAndOpenLeftNavbar(),
  //   );
  //   setTrackIsModalOpen(false);
  // };

  const handleCloseModal = () => {
    setshowAireviewContent(false);
    setTrackIsModalOpen(false);
    setIsChevronOpen(false); // reset shift

    // FORCE CLOSE RIGHT MODAL
    dispatch(closeRightModal());
    dispatch(closeRightModal());

    // Ensure no leftover lower modal
    dispatch(closeLowerModal());
    if (!mobileView) dispatch(openLeftNavbar());
    setTimeout(() => window.dispatchEvent(new Event("resize")), 100);
  };

  useEffect(() => {
    if (!rightModalOpen) {
      setIsChevronOpen(false);
    }
  }, [rightModalOpen]);

  // ── RIGHT PANEL COLUMN WIDTH ─────────────────────────────────────────────
  const showRightPanel =
    rightModalOpen && (isGrammarCheck || showAireviewContent);
  const showSuggestionPanel = isSuggestion && !mobileView;
  const activeOverlayWidth = !mobileView
    ? Math.max(
        showRightPanel ? REVIEW_PANEL_WIDTH : 0,
        isCoAuthorContentPanelOpen ? RIGHT_CONTENT_PANEL_WIDTH : 0,
        lowerModelOpen ? LOWER_MODEL_PANEL_WIDTH : 0,
        isChevronOpen ? CHEVRON_WIDTH : 0,
      )
    : 0;
  const editorColumnWidth =
    activeOverlayWidth > 0
      ? `calc(100% - ${activeOverlayWidth}px)`
      : showSuggestionPanel
        ? "66.667%"
        : "100%";
  const editorColSize =
    showRightPanel || showSuggestionPanel ? 8 : isCoAuthor ? 11 : 12;

  useEffect(() => {
    // Reflow editor when side/lower panels toggle.
    const triggerResize = () => window.dispatchEvent(new Event("resize"));
    triggerResize();
    const timer = setTimeout(triggerResize, 320);
    return () => clearTimeout(timer);
  }, [showRightPanel, showSuggestionPanel, lowerModelOpen, activeOverlayWidth]);

  // ── BOTTOM TOOLBAR PROPS ──────────────────────────────────────────────────
  const bottomToolbarProps = {
    mobileView,
    totalWords,
    accessToParaphrase,
    accessToSummarize,
    accessToOCR,
    accessToDelete,
    accessToUpload,
    accessToTranslate,
    accessToEdit,
    isDarkMode,
    isRecording,
    trial,
    isGrammarCheck,
    docId,
    handleParaphraseClick,
    handleSummariserClick,
    ocrCheck,
    grammarCheckClick,
    handleDeleteFormain,
    handleFileChange,
    openDownloadModal,
    handleCopyFormain,
    handleTranslateClick,
    handleMicClick,
    paraphrase_logo,
    paraphrase_White,
    paraphrase_Gray,
    editorStyle,
  };

  return (
    <>
      {/* ── Global styles ── */}
      <style>{`
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
        @keyframes slideInRight {
          from { transform: translateX(100%); opacity: 0; }
          to   { transform: translateX(0);   opacity: 1; }
        }
        @keyframes fadeIn { from{opacity:0;transform:translateY(4px)} to{opacity:1;transform:translateY(0)} }
        .coauthor-editor-wrap { animation: fadeIn 0.25s ease; }
        .suggestion-panel-enter { animation: slideInRight 0.25s ease; }
        .right-panel-enter { animation: slideInRight 0.25s ease; }
      `}</style>

      <SubscriptionRequired
        open={subReqOpen}
        setOpen={setSubReqOpen}
        isFeatureInside={isFeatureInside}
        setIsFeatureInside={setIsFeatureInside}
        path={"mydocuments"}
      />

      {/* ── WORD LIMIT WARNING DIALOG (NEW) ── */}
      <Dialog
        open={wordLimitDialogOpen}
        onClose={handleWordLimitDialogClose}
        aria-labelledby="word-limit-dialog-title"
        aria-describedby="word-limit-dialog-description"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: 3,
            padding: 2,
            minWidth: 400,
            background: isDarkMode ? "#1e293b" : "#ffffff",
            color: isDarkMode ? "#ffffff" : "#000000",
          },
        }}
      >
        <DialogTitle
          id="word-limit-dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "#ef4444",
            fontWeight: 600,
          }}
        >
          <WarningIcon sx={{ fontSize: 28 }} />
          Word Limit Exceeded
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="word-limit-dialog-description"
            sx={{
              color: isDarkMode ? "#94a3b8" : "#4b5563",
              fontSize: "1rem",
            }}
          >
            You have entered <strong>{totalWords}</strong> words, which exceeds
            the maximum limit of <strong>2500 words</strong>.
          </DialogContentText>
          <Box
            sx={{
              mt: 2,
              p: 2,
              bgcolor: isDarkMode ? "#334155" : "#f3f4f6",
              borderRadius: 2,
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: isDarkMode ? "#e2e8f0" : "#1f2937" }}
            >
              Please reduce your text to 2500 words or less to continue with AI
              features.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button
            onClick={handleWordLimitDialogClose}
            variant="contained"
            sx={{
              bgcolor: "#ef4444",
              "&:hover": {
                bgcolor: "#dc2626",
              },
              borderRadius: 2,
              px: 4,
            }}
          >
            OK, Got it
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── CoAuthor sidebar modal (unchanged) ── */}
      {selectedEditOption && isCoAuthor && !mobileView && !isSuggestion && (
        <CoauthorModal
          trial={trial}
          userId={userId}
          state={editorContent}
          setEditorState={setEditorState}
          setState={setEditorContent}
          count={totalWords}
          passNametoCoNewProject={passNametoCoNewProject}
          setTrackIsModalOpen={setTrackIsModalOpen}
          editorValue={editorValue}
          onChevronToggle={setIsChevronOpen}
          desktopDrawerWidth={CHEVRON_WIDTH}
          desktopPanelWidth={RIGHT_CONTENT_PANEL_WIDTH}
          onToolPanelOpen={handleSwitchToRightToolPanel}
        />
      )}

      {/* ── RIGHT PANEL (AI Review / Grammar) ── */}
      {showRightPanel && (
        <Paper
          elevation={0}
          className="right-panel-enter"
          sx={{
            width: mobileView ? "65%" : `${REVIEW_PANEL_WIDTH}px`,
            minWidth: mobileView ? "65%" : `${REVIEW_PANEL_WIDTH}px`,
            maxWidth: mobileView ? "65%" : `${REVIEW_PANEL_WIDTH}px`,
            height: "calc(100vh - 80px)",

            top: 70,
            right: 0,
            zIndex: 1200,
            overflowY: "auto",
            borderLeft: `1px solid ${COLORS.border}`,
            bgcolor: COLORS.surface,
            boxShadow: SHADOW.panel,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <PanelHeader
            title={showAireviewContent ? "AI Review" : "Grammar Check"}
            icon={
              <img
                src={aireviewicon}
                alt="AI Review"
                style={{ width: 24, height: 24, objectFit: "contain" }}
              />
            }
            onClose={handleCloseModal}
          />
          {(showAireviewContent || isGrammarCheck) && (
            <Box sx={{ flex: 1, overflow: "auto" }}>
              <CoAuthor_Aireviewcomponent
                mobileView={mobileView}
                editorState={editorContent}
                count={totalWords}
                isGrammarCheck={isGrammarCheck}
                userId={userId}
                trial={trial}
                editorValue={editorValue}
              />
            </Box>
          )}
        </Paper>
      )}

      {/* ── Lower modal (Translate/Summarize/Paraphrase) ── */}
      <CoAuthorLowerModel
        isDarkMode={isDarkMode}
        mobileView={mobileView}
        editorRef={editorRef}
        editorValue={editorValue}
        showTranslateModel={showTranslateModel}
        handleCloseTranslate={handleCloseTranslate}
        editorState={editorContent}
        selectedContent={selectedContent}
        setSelectedContent={setSelectedContent}
        translator={showTranslator1}
        setTranslator={setShowTranslator1}
        summariser={showSummariser1}
        setSummariser={setShowSummariser1}
        paraphraser={showParaphraser1}
        setParaphraser={setShowParaphraser1}
        callGrammerCheck={callGrammerCheck}
        setCallGrammerCheck={setCallGrammerCheck}
        callSummarise={callSummarise}
        setCallSummarise={setCallSummarise}
        onChildStateChange={handleChildStateChange}
        firstTime={firstTime}
        setFirstTime={setFirstTime}
        righteditorContent={secondaryeditorStateSummarizer}
        handleDeleteinSummarizer={handleDeleteInSummarizer}
        sharedState={docName}
        setTrackIsModalOpen={setTrackIsModalOpen}
        desktopWidth={LOWER_MODEL_PANEL_WIDTH}
      />

      <Loader loading={loading} />

      {/* ── Trial/Grammar header labels ── */}
      {isGrammarCheck && trial && (
        <Box sx={{ ml: 1.5, mt: 5 }}>
          <HeadingB text="Grammar Check" />
        </Box>
      )}
      {isCoAuthor && trial && (
        <Box sx={{ ml: 1.5, mt: 5 }}>
          <HeadingB text="Co-Author" />
        </Box>
      )}

      {/* ── MAIN LAYOUT ── */}
      <Box
        sx={{
          display: "flex",
          width: "100%",
          gap: 2,
          ml: trial ? "25px" : 0,
          padding: "24px",
          alignItems: "flex-start",
        }}
      >
        {/* ── EDITOR COLUMN ── */}
        <Box
          id="editor-root"
          className="coauthor-editor-wrap"
          sx={{
            flex: 1,
            minWidth: 0,
            transition: "width 0.3s ease",
            width: editorColumnWidth,
            maxWidth: editorColumnWidth,
            pl: 0,
            pr: mobileView ? 0 : "",
            ...editorShiftStyle,
          }}
        >
          {/* Top menu bar (unchanged) */}
          <Box sx={{ ...editorStyle }}>
            <CoAutherTopMenubar
              mobileView={mobileView}
              editor={editorRef}
              windowWidth={windowWidth}
              ocrCheck={ocrCheck}
              normalSizeEditor={handleNormalSizeEditor}
              fullSizeEditor={handleFullSizeEditor}
              trial={trial}
              selectedEditOption={selectedEditOption}
              sharedDocument={sharedDocument}
              isCoAuthor={isCoAuthor}
              isGrammarCheck={isGrammarCheck}
              handleMenuItemClick={handleMenuItemClick}
              handleDownload={handleDownloadFormain}
              setEditorContentUpload={setEditorContentUpload}
              removeHighlight={removeHighlight}
              setRemoveHighlight={setRemoveHighlight}
              circularLoader={circularLoader}
              // setSharedState={setSharedState}
              setDocName={setDocName}
              docName={docName}
              editorState={editorValue}
              // newProject={handleNewproject}
              handleWordCountExceed={handleWordCountExceed}
              setMaxCountDisplayed={setMaxCountDisplayed}
              docId={docId}
              newDocId={newDocId}
              setUpdateDocName={setUpdateDocName}
            />
          </Box>

          {/* Submit for review button */}
          {sharedDocument && !viewOnlyAccess && docId && (
            <Box
              sx={{ position: "absolute", zIndex: 1500, top: 88, right: 20 }}
            >
              <Button
                variant="outlined"
                color="primary"
                onClick={submitForReview}
                disabled={clickSubmitForReview}
                sx={{
                  borderRadius: RADIUS.md,
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.82rem",
                  px: 2.5,
                  borderWidth: 1.5,
                }}
              >
                Submit for Review
              </Button>
            </Box>
          )}

          {/* ── RICH TEXT EDITOR ── */}
          <Paper
            elevation={0}
            sx={{
              ...editorStyle,
              borderRadius: RADIUS.lg,
              overflow: "hidden",
              border: `1.5px solid ${COLORS.border}`,
              boxShadow: SHADOW.md,
              bgcolor: COLORS.surface,
              mt: 0.5,
            }}
          >
            <RichTextEditor
              editor={editorRef}
              editorContent={editorContent}
              onChange={handleChangeEditor}
              showtoolbar={true}
              readOnly={false}
              minHeight={
                mobileView ? "calc(100vh - 420px)" : "calc(100vh - 340px)"
              }
              maxHeight={
                mobileView ? "calc(100vh - 360px)" : "calc(100vh - 280px)"
              }
              editorId={1}
            />
          </Paper>

          {/* ── BOTTOM TOOLBAR ── */}
          {selectedEditOption && (
            <>
              <BottomToolbar {...bottomToolbarProps} />
              <DownloadOptionModal
                show={isDownloadModalOpen}
                onHide={closeDownloadModal}
                id={docId}
              />
            </>
          )}
        </Box>

        {/* ── SUGGESTION PANEL (desktop) ── */}
        {showSuggestionPanel && (
          <Paper
            elevation={0}
            className="suggestion-panel-enter"
            sx={{
              flex: "0 0 33.333%",
              maxWidth: "33.333%",
              height: "calc(100vh - 130px)",
              maxHeight: "calc(100vh - 130px)",
              minHeight: 0,
              borderRadius: RADIUS.lg,
              border: `1.5px solid ${COLORS.border}`,
              boxShadow: SHADOW.panel,
              bgcolor: COLORS.surface,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Panel Header */}
            <Box
              sx={{
                px: 2.5,
                pt: 2,
                pb: 1.5,
                borderBottom: `1px solid ${COLORS.border}`,
                bgcolor: COLORS.surface,
                position: "sticky",
                top: 0,
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 1.25,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "1rem",
                    color: COLORS.textPrimary,
                    letterSpacing: "-0.01em",
                  }}
                >
                  Suggestions
                </Typography>
                {sentenceResult.length > 0 && (
                  <Chip
                    label={sentenceResult.length}
                    size="small"
                    sx={{
                      bgcolor: COLORS.accentLight,
                      color: COLORS.accent,
                      fontWeight: 700,
                      fontSize: "0.75rem",
                      height: 22,
                    }}
                  />
                )}
              </Box>

              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  size="small"
                  variant="outlined"
                  color="error"
                  disabled={sentenceResult.length > 0 ? false : true}
                  onClick={() => setIgnoreAllClicked(true)}
                  sx={{
                    borderRadius: RADIUS.md,
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "0.78rem",
                    flex: 1,
                    borderWidth: 1.5,
                  }}
                >
                  Ignore All
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => setAcceptAllClicked(true)}
                  disabled={sentenceResult.length > 0 ? false : true}
                  sx={{
                    borderRadius: RADIUS.md,
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "0.78rem",
                    flex: 1,
                    bgcolor: COLORS.accent,
                    boxShadow: "none",
                    "&:hover": {
                      bgcolor: COLORS.accentDark,
                      boxShadow: "none",
                    },
                  }}
                >
                  Accept All
                </Button>
              </Box>
            </Box>

            {/* Suggestion list */}
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <SuggestionComp
                autoSaveContent={autoSaveContent}
                windowWidth={windowWidth}
                ignoreAllClicked={ignoreAllClicked}
                setIgnoreAllClicked={setIgnoreAllClicked}
                acceptAllClicked={acceptAllClicked}
                setAcceptAllClicked={setAcceptAllClicked}
                editorContent={editorContent}
                changedSentence={sentenceResult}
                setSentenceResult={setSentenceResult}
                editorValue={editorValue}
                setEditorValue={setEditorValue}
                setIsSuggestion={setIsSuggestion}
                editor={editorRef}
                ignoredSuggestions={ignoredSuggestions}
                setNewSentences={setNewSentences}
                newSentences={newSentences}
                suggestionLoader={suggestionLoader}
                setEditorState={setEditorContent}
              />
            </Box>
          </Paper>
        )}

        {/* ── SUGGESTION PANEL (mobile) ── */}
        {isSuggestion && mobileView && (
          <Paper
            elevation={4}
            sx={{
              position: "fixed",
              top: 75,
              right: 5,
              width: "60%",
              height: "70vh",
              minHeight: 0,
              zIndex: 998,
              overflow: "hidden",
              borderRadius: RADIUS.lg,
              border: `1.5px solid ${COLORS.border}`,
              bgcolor: COLORS.surface,
              boxShadow: SHADOW.lg,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                px: 2,
                py: 1.5,
                borderBottom: `1px solid ${COLORS.border}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "0.9rem",
                  color: COLORS.textPrimary,
                }}
              >
                Suggestions
              </Typography>
              <Box sx={{ display: "flex", gap: 0.75 }}>
                <Button
                  size="small"
                  variant="outlined"
                  color="error"
                  onClick={() => setIgnoreAllClicked(true)}
                  sx={{
                    borderRadius: RADIUS.sm,
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "0.72rem",
                    borderWidth: 1.5,
                  }}
                >
                  Ignore All
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => setAcceptAllClicked(true)}
                  sx={{
                    borderRadius: RADIUS.sm,
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "0.72rem",
                    bgcolor: COLORS.accent,
                    boxShadow: "none",
                    "&:hover": {
                      bgcolor: COLORS.accentDark,
                      boxShadow: "none",
                    },
                  }}
                >
                  Accept All
                </Button>
              </Box>
            </Box>
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <SuggestionComp
                autoSaveContent={autoSaveContent}
                windowWidth={windowWidth}
                ignoreAllClicked={ignoreAllClicked}
                setIgnoreAllClicked={setIgnoreAllClicked}
                acceptAllClicked={acceptAllClicked}
                setAcceptAllClicked={setAcceptAllClicked}
                editorContent={editorContent}
                changedSentence={sentenceResult}
                setSentenceResult={setSentenceResult}
                editorValue={editorValue}
                setEditorValue={setEditorValue}
                setIsSuggestion={setIsSuggestion}
                editor={editorRef}
                ignoredSuggestions={ignoredSuggestions}
                setNewSentences={setNewSentences}
                newSentences={newSentences}
                suggestionLoader={suggestionLoader}
                setEditorState={setEditorContent}
              />
            </Box>
          </Paper>
        )}

        {/* Mobile CoAuthor modal */}
        {selectedEditOption && isCoAuthor && mobileView && !isSuggestion && (
          <Box sx={{ width: "100%" }}>
            <CoauthorModal
              trial={trial}
              userId={userId}
              state={editorContent}
              editorState={editorState}
              setEditorState={setEditorState}
              setState={setEditorContent}
              count={totalWords}
              passNametoCoNewProject={passNametoCoNewProject}
              setTrackIsModalOpen={setTrackIsModalOpen}
              mobileView={mobileView}
              editorValue={editorValue}
              onChevronToggle={setIsChevronOpen}
              desktopDrawerWidth={CHEVRON_WIDTH}
              desktopPanelWidth={RIGHT_CONTENT_PANEL_WIDTH}
              onToolPanelOpen={handleSwitchToRightToolPanel}
            />
          </Box>
        )}
      </Box>

      {/* ── AI Assistant Modal (unchanged logic, modernized style) ── */}
      <Modal
        isOpen={isAIOpen}
        toggle={() => setIsAIOpen(!isAIOpen)}
        style={{ position: "absolute", left: "43%", top: "25%" }}
      >
        <ModalHeader toggle={() => setIsAIOpen(!isAIOpen)}>
          <Typography
            sx={{
              fontWeight: 700,
              color: COLORS.textPrimary,
              fontSize: "1rem",
            }}
          >
            AI Assistant
          </Typography>
        </ModalHeader>
        <ModalBody>
          <Box sx={{ mb: 2 }}>
            <Typography
              sx={{
                fontWeight: 600,
                color: COLORS.textPrimary,
                fontSize: "0.9rem",
                mb: 1,
              }}
            >
              Formality
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              {["neutral", "casual", "formal"].map((f) => (
                <TagButtonComp
                  key={f}
                  id={f}
                  name={f.charAt(0).toUpperCase() + f.slice(1)}
                  onClickTagButton={handleFormality}
                />
              ))}
            </Box>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography
              sx={{
                fontWeight: 600,
                color: COLORS.textPrimary,
                fontSize: "0.9rem",
                mb: 1,
              }}
            >
              Tone
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {[
                "personable",
                "confident",
                "empathetic",
                "engaging",
                "witty",
                "direct",
              ].map((t) => (
                <TagButtonComp
                  key={t}
                  id={t}
                  name={t.charAt(0).toUpperCase() + t.slice(1)}
                  onClickTagButton={handleTone}
                />
              ))}
            </Box>
          </Box>
          <Box sx={{ mt: 2 }}>
            <SelectDropdownMui
              optionsList={[
                { name: "Content Writer", value: "Content Writer" },
                { name: "Copywriter", value: "Copywriter" },
                { name: "Technical writer", value: "Technical writer" },
                { name: "Research Analyst", value: "Research Analyst" },
              ]}
              selectLabel="Your Profession"
              onChange={handleProfession}
              value={profession}
            />
          </Box>
          <Box sx={{ mt: 2.5, display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              onClick={updateAIAssistant}
              sx={{
                borderRadius: RADIUS.md,
                textTransform: "none",
                fontWeight: 600,
                bgcolor: COLORS.accent,
                "&:hover": { bgcolor: COLORS.accentDark },
                boxShadow: "none",
              }}
            >
              Update
            </Button>
          </Box>
        </ModalBody>
      </Modal>

      {/* Tour Bot */}
      {showCoAuthorBot && <CoAuthorTourBot />}
    </>
  );
};

export default CoAuthorNewProject;
